import { render, staticRenderFns } from "./CardHBarChart.vue?vue&type=template&id=1ad1a8a8&scoped=true"
import script from "./CardHBarChart.vue?vue&type=script&lang=js"
export * from "./CardHBarChart.vue?vue&type=script&lang=js"
import style0 from "./CardHBarChart.vue?vue&type=style&index=0&id=1ad1a8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1a8a8",
  null
  
)

export default component.exports